<template>
  <div>
    <HeadNav />
    <router-view />
    <FooterComponent />
  </div>
</template>

<script>
import HeadNav from "@/components/headNav.vue";
import FooterComponent from "@/components/footerComponent.vue";

export default {
  components: {
    HeadNav,
    FooterComponent,
  },
};
</script>

<style lang="scss" scoped></style>
